export const blockIconsSearchCoffee = (
	<span className='material-symbols-outlined'>coffee</span>
);
